import {inputType} from '../../esgManager/interface/inputType';

export const isTableFieldType = (question: any): boolean => {
  if (Array.isArray(question) && question.length > 0) {
    return (
      question[0].fieldType === inputType.ADD_MORE_FIELDS ||
      question[0].fieldType === inputType.ADD_NEW_TO_TABLE ||
      question[0].fieldType === inputType.ADD_FIXED_ROW_TO_TABLE ||
      question[0].fieldType === inputType.ADD_MORE_FIELDS_TOGGLE_TABLE
    );
  } else if (typeof question === 'object' && question !== null) {
    return (
      question.fieldType === inputType.ADD_MORE_FIELDS ||
      question.fieldType === inputType.ADD_NEW_TO_TABLE ||
      question.fieldType === inputType.ADD_FIXED_ROW_TO_TABLE ||
      question.fieldType === inputType.ADD_MORE_FIELDS_TOGGLE_TABLE
    );
  }

  return false;
};
